import { defineMessages } from 'react-intl';

export default defineMessages({
  expandPrioritiesLabel: {
    id: 'expandPrioritiesLabel',
    description: 'expand priorities',
    defaultMessage: 'expand priority',
  },
  collapsePrioritiesLabel: {
    id: 'collapsePrioritiesLabel',
    description: 'collapse priorities',
    defaultMessage: 'collapse priority',
  },
});
